import React, { Component } from 'react';
import { Header, Segment, Grid, Form } from 'semantic-ui-react';

import { SearchInputBox, Authority } from 'components/Commons';

import storage from 'helpers/storage';

import cm from 'helpers/commons';

import StaffMealList from './StaffMealList';

const propTypes = {};

const defaultProps = {};

class RightArea extends Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { param, tabType, staffCheckedData, userCnt, isLoadingBar } = this.props.data;
    const {
      param: nparam,
      tabType: ntabType,
      staffCheckedData: nstaffCheckedData,
      userCnt: nuserCnt,
      isLoadingBar: nisLoadingBar
    } = nextProps.data;
    const changeParams = param !== nparam; // true면 render
    const changeTabType = tabType !== ntabType; // true면 render
    const changeCheckedData = staffCheckedData !== nstaffCheckedData; // true면 render;
    const changeUserCnt = userCnt !== nuserCnt; //true면 render;
    const changeLoadingBar = isLoadingBar !== nisLoadingBar;
    return changeParams || changeTabType || changeCheckedData || changeUserCnt || changeLoadingBar;
  }

  render() {
    const { fn, data } = this.props;
    const comid = ((storage.get('company') || {}).info || {}).id;
    let navi = '전체';
    let options = [
      { value: null, text: '권한 전체' },
      { value: 30, text: '회사관리자' },
      { value: -1, text: '일시정지' }
    ];
    if (comid === 'B068366F-5EB8-1C7E-E79C-D438C8E32F9D') {
      options.push({ value: 99, text: '전체 관리자' });
    }
    if (data.param.orgCode) {
      navi = cm.divisionNavi(data.param.orgCode);
    }

    return (
      <Grid.Column>
        <Header className="staff-header" attached="top" block>
          {data.tabType === 'division' ? navi : '식대그룹'}
        </Header>
        <Segment attached className="divisionBudgetseg">
          {data.param.orgCode ? (
            <StaffMealList
              params={data.param}
              navi={navi}
              userTotal={data.userCnt}
              staffCheckedData={data.staffCheckedData}
              // isLoadingBar={data.isLoadingBar}
              staffSel={fn.staffSel}
              staffChecked={fn.staffChecked}
              isLoadingBarChange={fn.isLoadingBarChange}
            />
          ) : (
            <div>부서를 선택해 주세요</div>
          )}
        </Segment>
      </Grid.Column>
    );
  }
}

RightArea.propTypes = propTypes;
RightArea.defaultProps = defaultProps;

export default RightArea;
